import api from "../services/api";

const DISTRICT_ROLES = new Set([
  "Environmental District Officer",
  "district_EDO",
]);

const getCurrentRole = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}")?.role || "";
  } catch {
    return "";
  }
};

const getFilenameFromDisposition = (disposition) => {
  if (!disposition) return "";

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const basicMatch = disposition.match(/filename="?([^"]+)"?/i);
  return basicMatch?.[1] || "";
};

export const getDownloadEndpoint = (esmpId, role = getCurrentRole()) => {
  if (role === "reviewer") return `/reviewer/esmps/${esmpId}/download`;
  if (DISTRICT_ROLES.has(role)) return `/district/${esmpId}/download`;
  return `/esmp/${esmpId}/download`;
};

export const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename || "document");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadEsmpFile = async (esmp, role = getCurrentRole()) => {
  const res = await api.get(getDownloadEndpoint(esmp.id, role), {
    responseType: "blob",
  });

  const filename =
    esmp?.file_name ||
    getFilenameFromDisposition(res.headers?.["content-disposition"]) ||
    `${esmp?.esmp_id || "document"}`;

  triggerBrowserDownload(res.data, filename);
};
